import Cookies from "universal-cookie";

const cookies = new Cookies();

// Same dedicated back-office RestApi used by the supplier explorer, audit and integrations.
const BASE = process.env.BACKOFFICE_SERVER_URL || "";

const backofficeFetch = async (path, { method = "GET" } = {}) => {
  const { token } = cookies.get("userId") || {};
  try {
    const res = await fetch(`${BASE}${path}`, {
      method,
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await res.json().catch(() => null);
    if (!res.ok) return data ?? { message: "Erro ao comunicar com o servidor" };
    return data;
  } catch {
    return null;
  }
};

// One row per SIENGE client with the last recorded probe (loads instantly, no Sienge call).
export const fetchSiengePermissions = () =>
  backofficeFetch(`/integrations/listSiengePermissions`);

// Probes the given client's Sienge APIs live and records the result (one click = ~10 calls).
export const checkSiengePermissions = (companyId) =>
  backofficeFetch(`/integrations/checkSiengePermissions?company_id=${encodeURIComponent(companyId)}`, {
    method: "POST",
  });

// Pré-requisito da tela "New Building": testa a conectividade com o ERP da construtora antes
// de liberar o envio. Retorna `{supported: false, reason}` para ERPs sem sonda implementada
// (Mega, Prevision) e `{supported: true, scopes, denied}` para Sienge.
export const testConnection = (companyId) =>
  backofficeFetch(`/integrations/testConnection?company_id=${encodeURIComponent(companyId)}`, {
    method: "POST",
  });
